// eslint-disable-global no-unused-vars

const storedProducts = () => localStorage.getItem('products') && JSON.parse(localStorage.getItem('products')) || [];

jQuery( document ).ready(function () {
    jQuery('.remove-quote').click(function () {
        const product_id = jQuery(this).data('product_id')
        wishlistFavorites(this, product_id)
    });
    refreshCounter();
});

export function refreshCounter() {
    const buttons = document.querySelectorAll('.addquotelistbutton');

    buttons.forEach(button => {
        if (storedProducts().find(i => i.id === jQuery(button).data('product_id'))) {
            console.log("add checkmark")
            button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M186.301 339.893L96 249.461l-32 30.507L186.301 402 448 140.506 416 110z"/></svg>'
        } else {
            if (jQuery(button).hasClass('add-to-quote')) {
                button.innerHTML = 'voeg toe aan offerte';
            } else {
                button.innerHTML = 'Offerte';
            }
        }
    });

    if (storedProducts().length > 0) {
        if (!jQuery('.floating-quote-list').hasClass("shown"))  {
            jQuery('.floating-quote-list').addClass("shown");
        }
        jQuery('.quote-count').show();
        jQuery('.quote-count').text(storedProducts().length);
        //jQuery('.amount-favorites strong').text(JSON.parse(Cookies.get('posts_in_wishlist')).length);
    } else {
        jQuery('.quote-count').hide();
        jQuery('.floating-quote-list').hide();
        jQuery('#gform_wrapper_3').hide();
    }
}

export function wishlist(element, post_id, quantity = 1) {
    const post = { id: post_id, quantity: quantity };

    let liked = [];
    if (localStorage.getItem('products') != null) {
        liked = storedProducts()
    }

    // Check if its an old version
    const isOld = liked.filter(item => typeof item === 'number');
    if (isOld.length > 0) {
        localStorage.setItem('products', JSON.stringify([]));
        liked = [];
    }

    // Check if post_id exists in array
    let index = liked.findIndex(_post => _post.id === post.id);

    if (index === -1) {
        // If post_id doesnt exist push to array
        liked.push(post);

        //element.classList.add("liked");
        //element.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M186.301 339.893L96 249.461l-32 30.507L186.301 402 448 140.506 416 110z"/></svg>'

    } else {
        // If it does exist remove it.
        liked.splice(index, 1);
        element.classList.remove("liked");
        element.innerHTML = 'Offerte'
    }

    const json = JSON.stringify(liked);

    localStorage.setItem('products', json);
    refreshCounter();
}

export function wishlistFavorites(element, post_id) {
    const post = { id: post_id, quantity: 1 };

    let liked = [];
    if (localStorage.getItem('products') != null) {
        liked = storedProducts()
    }

    // Check if its an old version
    const isOld = liked.filter(item => typeof item === 'number');
    if (isOld.length > 0) {
        localStorage.setItem('products', JSON.stringify([]));
        liked = [];
    }

    // Check if post_id exists in array
    let index = liked.findIndex(_post => _post.id === post.id);

    if (index === -1) {
        // If post_id doesnt exist push to array
        liked.push(post_id);
    } else {
        // If it does exist remove it.
        liked.splice(index, 1);
    }

    var json = JSON.stringify(liked);

    localStorage.setItem('products', json);
    refreshCounter();
}
